/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Mxf_WrapInputs */



/**
* | output |
* | --- |
* | "MXF Wrap" |
*
* @param {Subtitle_Export_Mxf_WrapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_mxf_wrap = /** @type {((inputs?: Subtitle_Export_Mxf_WrapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Mxf_WrapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enveloppe MXF")
	if (locale === "de") return /** @type {LocalizedString} */ ("MXF Wrap")
	if (locale === "it") return /** @type {LocalizedString} */ ("MXF Wrap")
	if (locale === "ru") return /** @type {LocalizedString} */ ("MXF-пленка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Envoltura MXF")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("MXF 包覆")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MXFラップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एमएक्सएफ रैप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Envoltório MXF")
	return /** @type {LocalizedString} */ ("MXF Wrap")
});